import {ControlledAutocompleteSelectOption} from '@hm/fundamental'

import type {UpmFilterValue} from '../types'

import {BaseFilter} from './BaseFilter'

interface UpmHierarchyFiltersProps<Level extends string> {
  /** Ordered UPM levels to render (e.g. Area -> Country -> Plant). */
  levels: readonly Level[]
  /** Grouped, visible options per level (typically from the filters provider). */
  upmFilterValues: Record<Level, UpmFilterValue[]>
  /** Currently selected upmId groups per level. */
  selectedByLevel: Record<Level, string[]>
  /** Called when a level's selection changes. */
  onSyncLevel: (level: Level, upmIds: string[]) => void
  /** Returns the translated title for a level. */
  getLevelLabel: (level: Level) => string
  /** Returns the data-cy base name for a level. Defaults to `upm_<level>`. */
  getLevelName?: (level: Level) => string
}

export const UpmHierarchyFilters = <Level extends string>({
  levels,
  upmFilterValues,
  selectedByLevel,
  onSyncLevel,
  getLevelLabel,
  getLevelName
}: UpmHierarchyFiltersProps<Level>) => {
  return (
    <>
      {levels.map((level) => {
        const options: ControlledAutocompleteSelectOption[] = upmFilterValues[level].map(
          (option) => ({
            label: option.value,
            value: option.upmIds.join(',')
          })
        )
        return (
          <BaseFilter
            key={level}
            name={getLevelName ? getLevelName(level) : `upm_${level}`}
            title={getLevelLabel(level)}
            options={options}
            selectedValues={selectedByLevel[level]}
            setSelectedValues={(upmIds) => onSyncLevel(level, upmIds)}
          />
        )
      })}
    </>
  )
}
